import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { type CurbsideInfo } from '../api';
import { CURBSIDE_INFO_KEY } from './queryKey';
export type UseCurbsideQueryResult = {
  curbsideData: CurbsideInfo | undefined;
};
export const useCurbsideQuery = () => {
  const $ = _c(4);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = queryClient.getQueryData([CURBSIDE_INFO_KEY]);
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const curbsideData = t0;
  let t1;
  if ($[2] !== curbsideData) {
    t1 = {
      curbsideData
    };
    $[2] = curbsideData;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};